<template>
    <div class="flex flex-col w-full">
        <div class="flex w-full bg-gray-200 shadow-lg items-center mb-4">
            <div class="py-4 px-4 items-center  text-gray-700 hover:text-black cursor-pointer" @click="goBack">
                <ArrowLeftIcon class="mr-1 h-6 w-8 object-cover" ></ArrowLeftIcon>
<!--                                <p class="text-lg">Back</p>-->
            </div>

            <p class="visible justify-center text-center"> Add Photo Album</p>

        </div>


        <!-- loader -->
        <div v-if="info_loading" class="h-screen w-full">
            <div class="flex h-screen items-center">
                <vue-loaders
                    name="ball-spin-fade-loader"
                    color="#2a4365"
                    class="flex m-auto my-4"
                    scale="1"
                ></vue-loaders>
            </div>
        </div>


<!--        Textfield and label for Album name-->
        <div class="px-4">
            <div class="mb-6 md:mb-0 w-full md:w-1/3">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="name">
                    Album name <span class="text-red-600">*</span>
                </label>
                <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="name" type="text" placeholder="Valedictory service 1987" v-model="title" >
            </div>

            <file-selector v-model="selected_image" v-on:file_url="showImage"></file-selector>

            <div v-if="imageURLs.length > 0" class="grid grid-cols-1 row-gap-16 md:grid-cols-4 lg:grid-cols-4 mb-20">
                <div class="h-56 px-2 py-3 flex-col justify-center items-center" v-for="(image, index) in imageURLs" :key="index">
                    <img class="h-56 object-cover mx-auto" :alt="index" :src="image"/>
                    <div class="flex justify-center">
                        <button class=" px-2 py-1 bg-red-600 text-white hover:bg-red-800 cursor-pointer my-1 rounded text-center text-sm" @click="remove(index)">Remove</button>

                    </div>
                </div>
            </div>


            <div>
                <div v-if="save_loading" class="flex mx-auto mb-3" >
                        <vue-loaders name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1">
                        </vue-loaders>
                </div>

                <div v-else class="flex justify-start">
                    <button class=" px-10 py-3 bg-blue-500 text-white hover:bg-blue-800 cursor-pointer my-1 rounded text-center" @click="saveAlbum">Save Album</button>

                </div>
            </div>
                

        </div>

    </div>

</template>

<script>
    import FileSelector from "./FileSelector";
    import {ArrowLeftIcon} from 'vue-feather-icons';
    import Axios from 'axios';

    export default {
        name: "AddEditAlbum",
        components: {FileSelector, ArrowLeftIcon},
        props:{add: Boolean},
        data: function(){
            return {
                title: null,
                imageURLs:[],
                image64: [],
                selected_image: null,
                save_loading: false,
                info_loading: false,

            }
        },

        methods: {
            getBase64 : function(file){
                return new Promise((resolve, reject)=> {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);

                    reader.onerror = error => reject(error);
                })


            },


            showImage: function(image_url) {
                // console.log(image_url);
                // this.image_url = image_url;


                this.getBase64(this.selected_image).then(data => {

                    // console.log(data);
                    // this.image_string = data;
                    // this.images.push({image_url: image_url, image_string: data});
                    this.imageURLs.push(image_url);
                    this.image64.push(data);

                    this.selected_image = null;
                    // console.log(this.imageURLs);


                });
            },

            logout: function(){
                localStorage.clear();
                this.$router.push('/');
            },

            goBack: function(){
                this.$router.back();
            },

            remove: function(index){
                // this.images.splice(index, 1);
                this.imageURLs.splice(index, 1);
                this.image64.splice(index, 1);
            },

            saveAlbum: function(){
                this.save_loading = true;
                let token = localStorage.getItem('token');
                if(token !== null){

                    // let body = {
                    //         title: this.title,
                    //         photos: this.image64
                    //     };
                    // console.log(body);

                    if(this.add){
                        Axios.post('/api/gallery',
                            {
                                title: this.title,
                                photos: this.image64
                            },
                            {
                                headers: {
                                    'Content-Type' : 'application/json',
                                    'Authorization' : `Bearer ${token}`
                                }
                            }
                        ).then(response => {
                            this.save_loading = false;
                            if(response.data.status === true){
                                this.$swal({
                                    toast: true,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    position: 'top-end',
                                    title: response.data.message
                                });
                                this.$router.back();
                            }else{
                                this.$swal({
                                    toast: true,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    position: 'top-end',
                                    title: response.data.message
                                });
                            }
                        }).catch(e => {
                            console.log(e);
                        });
                    }else{
                        let id = this.$route.params.id;
                        Axios.patch(`/api/gallery/${id}`,
                            {
                                title: this.title,
                                photos: this.image64,
                            },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`
                                }
                            }
                        ).then(response => {
                            this.save_loading = false;
                            this.$swal({
                                toast: true,
                                showConfirmButton: false,
                                timer: 1500,
                                position: 'top-end',
                                title: response.data.message
                            });
                            if(response.data.status === true){
                                this.$router.back();
                            }
                        });
                    }


                    
                }
            },

            getAlbum: function(){


                if(!this.add){
                    this.info_loading = true;
                    let id = this.$route.params.id;
                    let token = localStorage.getItem('token');
                    this.imageURLs = [];
                    this.image64 = [];
                    Axios.get(`/api/gallery/${id}`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`

                            }
                        }
                    ).then(response => {
                        this.info_loading = false;
                        if(response.data.status === true){
                            this.title = response.data.data.title;
                            let photos = response.data.data.photos;

                            // console.log(photos);
                            photos.forEach((photo) => {


                                // console.log(name);
                                // let imgFile = new File(photo.photo_link, name);



                                this.fileFromURL(photo.photo_link).then(file => {

                                    this.getBase64(file).then(data =>{
                                            this.imageURLs.push(photo.photo_link);
                                            this.image64.push(data);
                                        }
                                    )
                                });
                            });

                        }
                    })
                }
            },

            fileFromURL: async function(imageUrl){
                let response = await fetch(imageUrl);
                let name = imageUrl.split('/');
                name = name[name.length - 1];
                let data = await response.blob();
                // let metadata = {
                //     type: 'image/jpeg'
                // };
                let file = new File([data], name);

                return file;


            }

        },

        created() {
            this.getAlbum();
        }

    }
</script>

<style scoped>

</style>
